var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerifiedBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1001_13334)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.82443 0.854102C8.5254 0.344814 9.4746 0.344814 10.1756 0.854102L16.3839 5.36475C17.0849 5.87403 17.3782 6.77677 17.1105 7.60081L14.7391 14.8992C14.4713 15.7232 13.7034 16.2812 12.837 16.2812H5.16302C4.29657 16.2812 3.52865 15.7232 3.2609 14.8992L0.889519 7.60081C0.621771 6.77677 0.915087 5.87403 1.61606 5.36475L7.82443 0.854102Z",
    fill: "#0A8A95"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 9L7.99765 11L12 7",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1001_13334",
    x: 0.791504,
    y: 0.472168,
    width: 16.417,
    height: 15.809,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1001_13334"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedBadge);
export default __webpack_public_path__ + "static/media/verified-badge.2714ddcdc77390527d18b80aa4422af2.svg";
export { ForwardRef as ReactComponent };